<template>
    <form autocomplete="off" class="trax-form-with-icons" v-on:submit.prevent="search">

        <!-- Task -->

        <trax-ui-select icon="assignment" v-model="form.type" :options="type_select"
            :unselected="lang.polaris.settings.task_filter_all">
        </trax-ui-select>

        <!-- Status -->

        <trax-ui-select icon="flag" v-model="form.status" :options="status_select"
            :unselected="lang.polaris.settings.task_filter_all">
        </trax-ui-select>

        <!-- Execution time -->

        <trax-ui-select icon="schedule" v-model="form.lane" :options="lane_select"
            :unselected="lang.polaris.settings.task_filter_all">
        </trax-ui-select>

        <!-- Submit buttons -->

        <div class="trax-form-actions text-right">
            <button type="button" class="btn btn-default btn-link" @click="reset"> {{ lang.polaris.form.reset }} </button>
            <button type="submit" class="btn btn-primary btn-round"> {{ lang.polaris.form.search }} </button>
        </div>

    </form>
</template>

<script>
    export default {

        props: {
            id: null,
            bus: null
        },

        data: function() {
            return {
                lang: lang,
                app_url: app_url,
                form: {},

                // The types come from the registry: a new task type appears here on its own.
                type_select: [],

                status_select: [
                    { name: lang.polaris.tasks.pending, value: 'pending' },
                    { name: lang.polaris.tasks.running, value: 'running' },
                    { name: lang.polaris.tasks.cancelling, value: 'cancelling' },
                    { name: lang.polaris.tasks.completed, value: 'completed' },
                    { name: lang.polaris.tasks.failed, value: 'failed' },
                    { name: lang.polaris.tasks.cancelled, value: 'cancelled' },
                ],

                lane_select: [
                    { name: lang.polaris.settings.task_lane_now, value: 'now' },
                    { name: lang.polaris.settings.task_lane_night, value: 'night' },
                ]
            }
        },

        created: function() {
            var that = this;

            this.bus.$on(this.id+'-filter-restore', function (data) {
                that.form = data;
            });

            this.getTypes();
        },

        methods: {

            getTypes() {
                var that = this;
                axios.get(this.app_url+'polaris/api/front/tasks/types')
                    .then(function (response) {
                        that.type_select = response.data.data.map(function (type) {
                            var label = lang.polaris.settings['task_type_' + type];
                            return { name: label ? label : type, value: type };
                        });
                    })
                    .catch(function (error) {
                    });
            },

            search() {
                this.bus.$emit(this.id+'-filter', this.form);
                this.bus.$emit(this.id+'-search-close');
            },

            reset() {
                this.form = {};
                this.search();
            }
        }

    }
</script>
